module.exports = __webpack_public_path__ + "img/ai_gentext.1ee3d182.svg";